(() => {
  const key = 'rumi-appearance';
  const root = document.documentElement;
  let preference = 'auto';
  try { preference = localStorage.getItem(key) || 'auto'; } catch (_) {}
  if (!['auto', 'light', 'dark'].includes(preference)) preference = 'auto';

  // Approximate solar position for Port Coquitlam, BC. No location permission needed.
  function isNight(date) {
    const radians = Math.PI / 180;
    const day = (Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - Date.UTC(date.getUTCFullYear(), 0, 0)) / 86400000;
    const hour = date.getUTCHours() + date.getUTCMinutes() / 60;
    const gamma = 2 * Math.PI / 365 * (day - 1 + (hour - 12) / 24);
    const equation = 229.18 * (0.000075 + 0.001868 * Math.cos(gamma) - 0.032077 * Math.sin(gamma) - 0.014615 * Math.cos(2 * gamma) - 0.040849 * Math.sin(2 * gamma));
    const declination = 0.006918 - 0.399912 * Math.cos(gamma) + 0.070257 * Math.sin(gamma) - 0.006758 * Math.cos(2 * gamma) + 0.000907 * Math.sin(2 * gamma) - 0.002697 * Math.cos(3 * gamma) + 0.00148 * Math.sin(3 * gamma);
    const solarMinutes = ((hour * 60 + equation + 4 * -122.78) % 1440 + 1440) % 1440;
    const angle = (solarMinutes / 4 - 180) * radians;
    const latitude = 49.26 * radians;
    const sunHeight = Math.sin(latitude) * Math.sin(declination) + Math.cos(latitude) * Math.cos(declination) * Math.cos(angle);
    return sunHeight < Math.sin(-0.833 * radians);
  }

  function apply() {
    const mode = preference === 'auto' ? (isNight(new Date()) ? 'dark' : 'light') : preference;
    root.dataset.rumiTheme = mode;
    root.style.colorScheme = mode;
    document.querySelectorAll('.rumi-appearance-popover>summary').forEach(trigger => {
      const label = `${mode === 'dark' ? 'Dark' : 'Light'} appearance${preference === 'auto' ? ' · Auto' : ''}. Change appearance`;
      trigger.setAttribute('aria-label', label);
      trigger.setAttribute('title', label);
    });
    document.querySelectorAll('[data-rumi-mode]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.rumiMode === preference));
    });
  }
  apply();
  document.addEventListener('DOMContentLoaded', () => {
    apply();
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-rumi-mode]');
      document.querySelectorAll('.rumi-appearance-popover[open]').forEach(popover => {
        if (!popover.contains(event.target) || button) popover.open = false;
      });
      if (!button) return;
      preference = button.dataset.rumiMode;
      try { localStorage.setItem(key, preference); } catch (_) {}
      apply();
      const popover = button.closest('.rumi-appearance-popover');
      if (popover) popover.querySelector('summary').focus();
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.rumi-appearance-popover[open]').forEach(popover => {
        popover.open = false;
        popover.querySelector('summary').focus();
      });
    });
  });
  setInterval(apply, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) apply(); });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    preference = ['light', 'dark'].includes(event.newValue) ? event.newValue : 'auto';
    apply();
  });
})();
